import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'

export const CreatedDate = ({ createdDate }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div>
      <Translate value="common.order.businessCreditReport.DATE_CREATED" />
      <span>: {formatDateTime(createdDate, FORMAT.DATE, locale)}</span>
    </div>
  )
}

CreatedDate.propTypes = {
  createdDate: PropTypes.string,
}
